import { render, staticRenderFns } from "./modalMotivoExclusao.vue?vue&type=template&id=6c02ecaa"
import script from "./modalMotivoExclusao.vue?vue&type=script&lang=js"
export * from "./modalMotivoExclusao.vue?vue&type=script&lang=js"
import style0 from "./modalMotivoExclusao.vue?vue&type=style&index=0&id=6c02ecaa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports